import { createRouter, createWebHistory } from "vue-router";
import CardanoMintNft from "@/views/CardanoMintNft.vue";
import ViewProfile from "@/views/ViewProfile.vue";
import EditProfile from "@/views/EditProfile.vue";
import Error404 from "@/views/Error404.vue";

import api from "../services/api";
import { ethereumService } from "../main";
import store from "../store";
import NftDetails from "@/views/NftDetails";

import useAuth from "../composables/useAuth";
import { trackRouter } from "vue-gtag-next";

const routes = [
  {
    path: "/",
    name: "Home",
    component: CardanoMintNft,
    beforeEnter: async (to, from, next) => {
      try {
        const response = await api.fetchMe();
        if (response.status === 200) return next();
      } catch (err) {
        const { disconnectInRouter } = useAuth(store, ethereumService);
        await disconnectInRouter();
        next();
      }
    },
  },
  {
    path: "/cardano",
    name: "Cardano",
    component: CardanoMintNft,
    beforeEnter: async (to, from, next) => {
      try {
        const response = await api.fetchMe();
        if (response.status === 200) return next();
      } catch (err) {
        const { disconnectInRouter } = useAuth(store, ethereumService);
        await disconnectInRouter();
        next();
      }
    },
  },
  {
    path: "/profile",
    name: "ViewProfile",
    component: ViewProfile,
    beforeEnter: async (to, from, next) => {
      try {
        const response = await api.fetchMe();
        if (response.status === 200) return next();
      } catch (err) {
        const { disconnectInRouter } = useAuth(store, ethereumService);
        await disconnectInRouter();
        next("/");
      }
    },
  },
  {
    path: "/edit-profile",
    name: "EditProfile",
    component: EditProfile,
    beforeEnter: async (to, from, next) => {
      try {
        const response = await api.fetchMe();
        if (response.status === 200) return next();
      } catch (err) {
        const { disconnectInRouter } = useAuth(store, ethereumService);
        await disconnectInRouter();
        next("/");
      }
    },
  },
  {
    path: "/nft-details/:id",
    name: "NftDetails",
    component: NftDetails,
    beforeEnter: async (to, from, next) => {
      try {
        const response = await api.fetchMe();
        if (response.status === 200) return next();
      } catch (err) {
        const { disconnectInRouter } = useAuth(store, ethereumService);
        await disconnectInRouter();
        next("/");
      }
    },
  },
  {
    path: "/404",
    name: "Error404",
    component: Error404,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "Error404",
    component: Error404,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

trackRouter(router, {
  useScreenview: true,
});

export default router;
